import { msg } from '@lingui/core/macro';
import { OldSubCategoryType } from '@/@types';

const placesFilters = [
  {
    id: '139',
    title: msg`Beauty`,
    name: 'Beauty',
  },
  {
    id: '105',
    title: msg`Library`,
    name: 'Library',
  },
  {
    id: '35',
    title: msg`Camping`,
    name: 'Camping',
  },
  {
    id: '131',
    title: msg`Educational Center`,
    name: 'Educational Center',
  },
  {
    id: '133',
    title: msg`Medical center`,
    name: 'Medical center',
  },
  {
    id: '103',
    title: msg`Movie Theater`,
    name: 'Movie Theater',
  },
  {
    id: '13',
    title: msg`Electronic`,
    name: 'Electronic',
  },
  {
    id: '107',
    title: msg`Others`,
    name: 'Others',
  },
  {
    id: '39',
    title: msg`Service Station`,
    name: 'Service Station',
  },
  {
    id: '9',
    title: msg`Pharmacy`,
    name: 'Pharmacy',
  },
  {
    id: '79',
    title: msg`Gym`,
    name: 'Gym',
  },
  {
    id: '11',
    title: msg`Home`,
    name: 'Home',
  },
  {
    id: '136',
    title: msg`Hotel`,
    name: 'Hotel',
  },
  {
    id: '121',
    title: msg`Gardens and Flowers`,
    name: 'Gardens and Flowers',
  },
  {
    id: '1',
    title: msg`Bookshop`,
    name: 'Bookshop',
  },
  {
    id: '119',
    title: msg`Fashion`,
    name: 'Fashion',
  },
  {
    id: '104',
    title: msg`Monuments`,
    name: 'Monuments',
  },
  {
    id: '21',
    title: msg`Museum`,
    name: 'Museum',
  },
  {
    id: '137',
    title: msg`Hair Salon`,
    name: 'Hair Salon',
  },
  {
    id: '36',
    title: msg`Spa`,
    name: 'Spa',
  },
  {
    id: '10',
    title: msg`Food store`,
    name: 'Food store',
  },
  {
    id: '125',
    title: msg`Dry Cleaner / Laundry`,
    name: `Dry Cleaner / Laundry`,
  },
] as OldSubCategoryType[];

export default placesFilters;
